module.exports = {"id":"193884","name":"Sam Clucas","rating":"73","photo":"./data/images/photos/1/193884.png","club":{"name":"Swansea City","logo":"./data/images/clubs/SwanseaCity.png"},"positions":["MC","MG"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SamClucas0.json
// module id = 3787
// module chunks = 0